<template>
  <AsidePanel
    ref="asidePanel"
    :components="components"
    :isExpanded="isExpanded"
    :itemType="itemType"
    :showSaveButton="false"
    :viewport="viewport"
  >
    <template v-slot:avatar>
      <AsideIcon
        icon="commands"
      />
    </template>
  </AsidePanel>
</template>

<script>
import {
  CommandTemplatesConsts,
  DeviceSupportedOSLabels,
  ItemTypeConsts,
  ItemTypeRoutes,
} from 'client/util/Constants';
import AsideIcon from 'client/components/AsidePanel/AsideIcon.vue';
import AsidePanel from 'client/components/AsidePanel/AsidePanel.vue';
import AsidePanelPropsMixin from 'client/components/AsidePanel/mixins/AsidePanelPropsMixin';
import CommandTemplateItemTable from 'client/components/ItemTable/CommandTemplateItemTable.vue';

const { types: osTypes } = CommandTemplatesConsts;
const { windows, macos, linux } = DeviceSupportedOSLabels;

export default {
  name: 'CommandTemplateAsidePanel',
  components: {
    AsidePanel,
    AsideIcon,
  },

  mixins: [
    AsidePanelPropsMixin,
  ],

  props: {
    itemType: {
      type: String,
      default: ItemTypeConsts.commandTemplateWindows,
    },
  },
  data() {
    return {
      route: ItemTypeRoutes[this.itemType],
    };
  },
  computed: {
    components() {
      const componentList = [{
        backboneView: null,
        itemType: ItemTypeConsts.commandTemplateWindows,
        label: windows,
        vueComponent: CommandTemplateItemTable,
        vueComponentProps: {
          boundItemsUrl: undefined,
          inDetailsAsidePanel: false,
          os: osTypes.windows,
        },
      }, {
        backboneView: null,
        itemType: ItemTypeConsts.commandTemplateMacOs,
        label: macos,
        vueComponent: CommandTemplateItemTable,
        vueComponentProps: {
          boundItemsUrl: undefined,
          inDetailsAsidePanel: false,
          os: osTypes.mac,
        },
      }, {
        backboneView: null,
        itemType: ItemTypeConsts.commandTemplateLinux,
        label: linux,
        vueComponent: CommandTemplateItemTable,
        vueComponentProps: {
          boundItemsUrl: undefined,
          inDetailsAsidePanel: false,
          os: osTypes.linux,
        },
      }];
      return componentList;
    },
  },
};
</script>
